export default __webpack_public_path__ + "static/media/1-GLOBAL.fdface1e.pdf";